import * as types from "./types";

const mutations = {
    [types.GET_ITEMREORDERING_ID](state, itemID) {
        state.itemID = itemID;
    },
    [types.LOADING_ITEM](state, value) {
        state.loading = value;
    },
    [types.ADD_JC_BY_ITEMID](state, itemID) {        
        state.itemID.unshift(itemID);
    },
    [types.ADD_PO_BY_ITEMID](state, itemID) {        
        state.itemID.unshift(itemID);
    },
};

export default mutations;